import { FormattedMessage } from 'react-intl';

const MarketingPanel = () => (
  <aside className="tw:hidden tw:lg:flex tw:w-2/5 tw:bg-primary tw:items-center tw:justify-center tw:p-12">
    <div className="tw:bg-white tw:rounded-lg tw:p-8 tw:max-w-md tw:shadow-lg">
      <h2 className="tw:font-bold tw:text-[#3b9eff] tw:mb-4">
        <FormattedMessage
          id="sign-in-marketing-headline"
          defaultMessage="Trade smarter."
        />
      </h2>
      <p className="tw:text-base tw:text-gray-700 tw:leading-relaxed">
        <FormattedMessage
          id="sign-in-marketing-body"
          defaultMessage="The digital platform empowering 800+ agricultural companies to connect, negotiate, and achieve better trade outcomes."
        />
      </p>
    </div>
  </aside>
);

export default MarketingPanel;
